import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormControl, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UploadService } from 'src/app/services/upload.service';
import { BusinessType } from 'src/types';
import { v4 as uuidv4 } from 'uuid';
import { ValidationMessageFn } from 'src/app/components/inputs/types/validation-message-fn';
import { CommonModule } from '@angular/common';
import { SettingsCardPaymentsSectionComponent } from 'src/app/components/settings-card-payments-section/settings-card-payments-section.component';
import { BusinessDocumentUploadComponent } from 'src/app/components/business-document-upload/document-upload.component';
import { CardActivationService } from 'src/app/services/card-activation.service';
import { CardActivationBusinessDocuments } from '../../card-payments-activation/card-activation-business-documents/interfaces/card-activation-business-documents-interface';
import { SharedModule } from 'src/app/shared.module';
import { I18NEXT_SERVICE, I18NextPipe } from 'angular-i18next';
import {
  advancedPages,
  advancedPagesParams,
  advancedPagesParamsForeign,
} from '../advanced-data';
import { CtaButtonsComponent } from 'src/app/components/cta-buttons/cta-buttons.component';
import { DocumentUploadComponent } from 'src/app/components/document-upload/document-upload.component';
import { EMPTY, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-business-documents-th',
  standalone: true,
  imports: [
    CommonModule,
    SettingsCardPaymentsSectionComponent,
    BusinessDocumentUploadComponent,
    SharedModule,
    CommonModule,
    CtaButtonsComponent,
    SharedModule,
  ],
  templateUrl: './business-documents-th.component.html',
  styleUrl: './business-documents-th.component.scss',
})
export class BusinessDocumentsThComponent implements OnInit {
  public fileControl: FormControl = new FormControl();
  advancedPages: string[] = advancedPages;
  advancedPagesParams: { [index: string]: string } | null = null;
  public isLoading: boolean = false;
  public sampleImageUrl: string[] = [];
  public selectedBusinessType: BusinessType = {
    value: '',
    label: '',
    urls: [],
    requirements: [''],
  };
  public module: string = '';
  public fromTh: boolean = true;

  public documentTitle: string = '';
  public fileSizeLimit: number = 2 * 1024 * 1024;
  public documentURL: string | null = null;
  public documentSubtype: string | null = null;
  public currentDocuments: CardActivationBusinessDocuments[] = [];

  public merchantId: number | null = null;
  public currentRequirement: string = '';

  private i18nextPipe = inject(I18NextPipe);

  documentUrls: { [key: string]: string[] } = {
    'Business Registration Certificate / Company Certificate': [
      '../../../../assets/document-samples/business-registration.png',
    ],
    'List of Shareholders (BOJ 5)': [
      '../../../../assets/document-samples/shareholders-list.png',
    ],
  };

  public validationMessage: Record<string, ValidationMessageFn> = {
    fileRequired: () =>
      this.i18nextPipe.transform('file-upload.errors.file-required'),
    fileSizeTooLarge: () =>
      this.i18nextPipe.transform('file-upload.errors.file-size-4'),
    genericError: () =>
      this.i18nextPipe.transform('file-upload.errors.generic'),
    required: () =>
      this.i18nextPipe.transform('file-upload.errors.file-required'),
  };
  public errors: ValidationErrors | null | undefined = null;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private uploadService: UploadService,
    private cardActivationService: CardActivationService,
    private route: ActivatedRoute,
    @Inject(I18NEXT_SERVICE) private i18next: any
  ) {}

  onNextPressed = async () => {
    if (this.isLoading) {
      this.isLoading = false;
      return false;
    }
    this.isLoading = true;
    console.log('next pressed', this.documentTitle, this.documentSubtype);
    // if (this.currentRequirement) {
    console.log('IC02 Uploading start');
    const document = this.getRequirements(
      this.selectedBusinessType.value
    ).indexOf(this.documentTitle);

    console.log(
      document,
      this.getRequirements(this.selectedBusinessType.value),
      this.getRequirements(this.selectedBusinessType.value)[document]
    );

    const documentName = this.documentTitle
      .toLowerCase()
      .replace(/[^\w\s]/g, '')
      .replace(/\s+/g, '_');
    const documentExists = this.searchLatestDocumentName(documentName);
    const file = this.fileControl.value;
    if (!file && !documentExists) {
      this.fileControl.setErrors({ fileRequired: true });
      return false;
    } else if (file && !documentExists) {
      this.isLoading = true;
      if (this.merchantId) {
        const payload = {
          file: this.fileControl.value,
          merchant_id: this.merchantId,
          uid: uuidv4(),
          status: 'active',
          document_name: documentName,
          extras: JSON.stringify({
            id_subtype: null,
            expiration_date: null,
          }),
        };
        console.log('Document payload', payload, this.merchantId);

        const uploadresponse = await this.uploadFile(payload);
        if (uploadresponse == false) {
          return false;
        } else if (uploadresponse) {
          return true;
        }
        return false;

        // .then((result:any) => {
        //   if (result){
        //     this.fileControl.reset();
        //     return true
        //   }else{
        //     return false
        //   }

        // })

        // return await this.uploadFile(payload).then((result:any)=>{
        //   if(result){
        //     this.fileControl.reset();
        //     return true
        //   }
        //   return false
        // });
      }
    } else if (file && documentExists) {
      this.isLoading = true;
      if (this.merchantId) {
        const payload = {
          file: this.fileControl.value,
          merchant_id: this.merchantId,
          uid: uuidv4(),
          status: 'active',
          document_name: documentName,
          extras: JSON.stringify({
            id_subtype: null,
            expiration_date: null,
          }),
        };
        console.log('Document payload', payload, this.merchantId);
        return await this.uploadFile(payload).then((result: any) => {
          if (result) {
            this.fileControl.reset();
            return true;
          }
          return false;
        });
      }
    } else if (!file && documentExists) {
      // this.navigateToNextPage();
      return false;
    } else {
      return false;
    }
    return false;
  };

  ngOnInit(): void {
    // this.route.queryParams.subscribe((params:any)=>{
    //   const currentpagecount = parseInt(params["count"])
    //   this.advancedPagesParams = advancedPagesParams[currentpagecount]
    //   console.log("activatedroute queryParams", this.advancedPagesParams)
    //   this.documentTitle = this.advancedPagesParams!["doctype"];
    //   this.sampleImageUrl = this.documentUrls[this.documentTitle]
    //   this.errors = null
    //   this.isLoading = false
    // })

    this.route.queryParams.subscribe((params) => {
      setTimeout(() => {
        this.fileControl.reset();
        this.fileControl.setValue(null);
        this.fileControl.updateValueAndValidity();
        this.fileControl.markAsUntouched();
        this.fileControl.markAsPristine();
        this.fileControl.setValidators([Validators.required]);
      }, 500);

      this.module = params['module'] || null;
      this.documentSubtype = params['documentSubtype'] || null;
      console.log('Module:', this.module);
      console.log('Document Subtype:', this.documentSubtype);
      const currentpagecount = parseInt(params['count']);

      const selectedBusinessTypeJSON = JSON.parse(
        localStorage.getItem('selectedBusinessType') ?? ''
      );

      const businessType = selectedBusinessTypeJSON.value;
      if (businessType == 'foreignEntity')
        this.advancedPagesParams = advancedPagesParamsForeign[currentpagecount];
      else this.advancedPagesParams = advancedPagesParams[currentpagecount];
      console.log('activatedroute queryParams', this.advancedPagesParams);
      this.documentTitle = this.advancedPagesParams!['doctype'];
      this.sampleImageUrl = this.documentUrls[this.documentTitle];
      this.errors = null;
      this.isLoading = false;
    });

    // this.initializeComponent();

    // this.cardActivationService.getUploadedDocuments().subscribe({
    //   next: (response) => {
    //     this.currentDocuments = response;
    //     this.initializeComponent();
    //     console.log('IC00 Current documents', this.currentDocuments);
    //   },
    //   error: (error) => {
    //     console.error('Error getting uploaded documents:', error);
    //   },
    // });

    this.fileControl.valueChanges.subscribe((status) => {
      if (this.fileControl.status === 'INVALID') {
        this.errors = this.fileControl.errors;
        console.log('Errors', this.errors);
      } else {
        this.errors = null;
      }
    });
    this.merchantId = parseInt(localStorage.getItem('userId')!);
  }

  initializeComponent() {
    if (this.module && this.module === 'editDocument') {
      if (this.documentSubtype) {
        this.documentTitle = this.documentSubtype;
        this.sampleImageUrl = this.documentUrls[this.documentTitle] || [];
      }
    } else {
      const selectedBusinessTypeJSON = localStorage.getItem(
        'selectedBusinessType'
      );
      this.currentRequirement =
        localStorage.getItem('currentRequirement') ?? '';

      if (selectedBusinessTypeJSON) {
        this.selectedBusinessType = JSON.parse(selectedBusinessTypeJSON);
        console.log('IC Business Type', this.selectedBusinessType);

        if (!this.currentRequirement) {
          this.documentTitle = this.getRequirements(
            this.selectedBusinessType.value
          )[2];
          console.log(this.documentTitle, 'documentTitle');
          this.currentRequirement = this.documentTitle;
        } else {
          this.documentTitle = this.currentRequirement;
        }

        const requirementIndex = this.getRequirements(
          this.selectedBusinessType.value
        ).indexOf(this.documentTitle);
        this.sampleImageUrl =
          this.selectedBusinessType.urls[requirementIndex] || [];

        console.log('Current Requirement:', this.documentTitle);
      }

      if (this.documentTitle) {
        const documentName = this.documentTitle
          .toLowerCase()
          .replace(/[^\w\s]/g, '')
          .replace(/\s+/g, '_');

        this.documentURL = this.searchLatestDocumentName(documentName);
        console.log('LOG', this.documentURL, documentName);
      }
    }
  }

  async validateAndHandleLargeFile(
    file: File,
    idType: string
  ): Promise<File | null> {
    if (file.size > this.fileSizeLimit) {
      if (file.type !== 'application/pdf') {
        console.log('IC00 Trigger for image compression', file.size, idType);
        const compressedFile = await this.uploadService.compressImage(file);
        if (!compressedFile) {
          this.isLoading = false;
          console.log('Debug: Could not compress file');
          return null;
        }
        return compressedFile;
      } else {
        return file; // Return the same file if it is a pdf
      }
    }
    return file; // Return the same file if it's below the maximum
  }

  navigateToBusinessEntity() {
    if (
      this.currentRequirement ==
      'Business Registration Certificate / Company Certificate'
    ) {
      this.router.navigate(['/advanced/business-entity-th']);
    } else {
      this.localStorageService.setItem(
        'currentRequirement',
        'Business Registration Certificate / Company Certificate'
      );
      this.initializeComponent();
    }
  }

  searchLatestDocumentName(documentName: string): string | null {
    if (!this.currentDocuments) {
      return null;
    }
    for (let i = this.currentDocuments.length - 1; i >= 0; i--) {
      if (this.currentDocuments[i].document_type === documentName) {
        if (
          this.currentDocuments[i].document_url.includes(
            '18ce0496-be4c-47d0-ab61-a46f572b3510.png'
          )
        )
          return null;
        return this.currentDocuments[i].document_url;
      }
    }
    return null;
  }

  updateDocuments() {
    this.cardActivationService.getUploadedDocuments().subscribe({
      next: (response) => {
        this.currentDocuments = response;
        console.log('MARKER Current documents', this.currentDocuments);
      },
      error: (error) => {
        console.error('Error getting uploaded documents:', error);
      },
    });
  }

  async uploadFile(payload: any) {
    const validatedDocument = await this.validateAndHandleLargeFile(
      payload.file,
      payload.document_name
    );

    if (!validatedDocument) {
      this.fileControl.setErrors({ genericError: true });
      console.log('Could not validate document', this.merchantId);
      this.isLoading = false;
      return false;
    }

    if (validatedDocument.size > this.fileSizeLimit) {
      this.fileControl.setErrors({ fileSizeTooLarge: true });
      console.log('File size too large', validatedDocument.size);
      this.isLoading = false;
      return false;
    }

    return firstValueFrom(
      this.uploadService.uploadFile(
        validatedDocument,
        payload.merchant_id,
        payload.uid,
        payload.document_name,
        payload.status,
        payload.extras
      )
    );
    // .subscribe(
    //   (response) => {
    //     this.isLoading = false;
    //     console.log('IC03 Uploaded successfully:', response);
    //     this.fileControl.reset();
    //     console.log('Going to next page');
    //     this.updateDocuments();
    //     // this.navigateToNextPage();
    //   },
    //   (error) => {
    //     this.isLoading = false;
    //     console.error('Error uploading:', error);
    //   }
    // );
  }

  navigateToNextPage() {
    if (this.module && this.module === 'editDocument') {
      this.navigateToDocuments();
    }
    const requirements = this.getRequirements(this.selectedBusinessType.value);
    const currentIndex = requirements!.indexOf(this.documentTitle);

    if (currentIndex !== -1 && currentIndex < requirements!.length - 2) {
      this.documentTitle = requirements![currentIndex + 1];
      localStorage.setItem('currentRequirement', this.documentTitle);

      this.initializeComponent();
    } else {
      console.log('All requirements completed.');
      localStorage.removeItem('currentRequirement');
      if (
        this.getBusinessLabel(this.selectedBusinessType.value) !=
        'Foreign Entity'
      )
        this.router.navigate(['/advanced/business-tax-id']);
    }
  }

  handleNext() {
    console.log(this.currentRequirement);
    if (this.currentRequirement) {
      console.log('IC02 Uploading start');
      const document = this.getRequirements(
        this.selectedBusinessType.value
      ).indexOf('xBusiness Registration Certificate / Company Certificate');

      console.log(
        document,
        this.getRequirements(this.selectedBusinessType.value),
        this.getRequirements(this.selectedBusinessType.value)[document]
      );

      const documentName = this.getRequirements(this.selectedBusinessType.value)
        [document].toLowerCase()
        .replace(/[^\w\s]/g, '')
        .replace(/\s+/g, '_');
      const documentExists = this.searchLatestDocumentName(documentName);
      const file = this.fileControl.value;
      if (!file && !documentExists) {
        this.fileControl.setErrors({ fileRequired: true });
      } else if (file && !documentExists) {
        this.isLoading = true;
        if (this.merchantId) {
          const payload = {
            file: this.fileControl.value,
            merchant_id: this.merchantId,
            uid: uuidv4(),
            status: 'active',
            document_name: documentName,
            extras: JSON.stringify({
              id_subtype: null,
              expiration_date: null,
            }),
          };
          console.log('Document payload', payload, this.merchantId);
          this.uploadFile(payload);
        }
      } else if (file && documentExists) {
        this.isLoading = true;
        if (this.merchantId) {
          const payload = {
            file: this.fileControl.value,
            merchant_id: this.merchantId,
            uid: uuidv4(),
            status: 'active',
            document_name: documentName,
            extras: JSON.stringify({
              id_subtype: null,
              expiration_date: null,
            }),
          };
          console.log('Document payload', payload, this.merchantId);
          this.uploadFile(payload);
        }
      } else if (!file && documentExists) {
        this.navigateToNextPage();
      }
    }
  }

  navigateToDocuments(): void {
    const targetUrl = '/tabs/documents';
    const parameters = { documentUpdate: 'successful' };

    parent.postMessage(
      JSON.stringify({
        target: targetUrl,
        parameters: parameters,
      }),
      '*'
    );
  }

  handleUpdate() {
    if (this.documentSubtype) {
      this.isLoading = true;
      const documentName = this.documentSubtype
        .toLowerCase()
        .replace(/[^\w\s]/g, '')
        .replace(/\s+/g, '_');
      const file = this.fileControl.value;
      if (!file) {
        this.fileControl.setErrors({ fileRequired: true });
        this.isLoading = false;
      } else {
        if (this.merchantId) {
          const payload = {
            file: this.fileControl.value,
            merchant_id: this.merchantId,
            uid: uuidv4(),
            status: 'active',
            document_name: documentName,
            extras: JSON.stringify({
              id_subtype: null,
              expiration_date: null,
            }),
          };
          console.log('Document payload', payload, this.merchantId);
          this.uploadFile(payload);
        }
        // this.navigateBack()
      }
    }
  }

  getRequirements(type: string): string[] {
    return this.i18next.t(`business-types.${type}.requirements`, {
      returnObjects: true,
    });
  }

  getBusinessLabel(type: string): string {
    return this.i18next.t(`business-types.${type}.label`);
  }
}
